import { UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { INVENTORY_SETUP } from "../apiRoutes";

// Define the expected response type (adjust based on your API response)
export interface InventorySetup {
  name: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

export interface InventorySetupResponse {
  data: {
    records: InventorySetup[];
    pagination: { totalRecords: number }[];
  }[];
}


const fetchInventorySetup = async ({ data }: { data: FieldValues }) => {
  const response = await axiosAuth.get<InventorySetupResponse>(INVENTORY_SETUP, {
    params: data,
  });
  return response.data;
};

// Query hook
const useInventorySetupQuery = (
  data: FieldValues,
  queryParams?:
    | UseQueryOptions<InventorySetupResponse, Error, InventorySetupResponse, ["inventorySetup", FieldValues]>
    | UseMutationOptions<any, Error>
) =>
  useQuery<InventorySetupResponse, Error, InventorySetupResponse, ["inventorySetup", FieldValues]>({
    queryKey: ["inventorySetup", data],
    queryFn: () => fetchInventorySetup({ data }),
    ...(queryParams as any), // safely spread because TS can’t know if it's query or mutation
  });

export default useInventorySetupQuery;
